(() => {
  const CODE = 'RUZEFIRST30';
  const ELIGIBLE_PRODUCT_IDS = new Set(['8490240311485','8490241065149','8490245947581']);
  const discountUrl = `/discount/${encodeURIComponent(CODE)}?redirect=${encodeURIComponent('/checkout')}`;
  let lastEligible = null;

  const css = `
    .ruze-first30-offer{margin:0 0 14px;padding:12px 14px;border:1px solid rgba(200,166,106,.42);background:rgba(200,166,106,.08);color:inherit}
    .ruze-first30-offer strong{display:block;font-family:var(--ruze-heading,inherit);font-size:.72rem;letter-spacing:.1em;color:#c8a66a}
    .ruze-first30-offer span{display:block;margin-top:5px;font-size:.76rem;line-height:1.35;opacity:.82}
    .ruze-first30-offer b{font-weight:800;color:inherit}
    @media(max-width:680px){.ruze-first30-offer{padding:11px 12px}.ruze-first30-offer strong{font-size:.66rem}.ruze-first30-offer span{font-size:.72rem}}
  `;
  if (!document.getElementById('ruze-first30-offer-style')) {
    const style = document.createElement('style');
    style.id = 'ruze-first30-offer-style';
    style.textContent = css;
    document.head.appendChild(style);
  }

  const getCart = async () => {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
    if (!response.ok) throw new Error('Unable to read cart');
    return response.json();
  };

  const cartIsEligible = (cart) => Array.isArray(cart?.items) && cart.items.some((item) => ELIGIBLE_PRODUCT_IDS.has(String(item.product_id)));

  const offerMarkup = () => {
    const wrap = document.createElement('div');
    wrap.className = 'ruze-first30-offer';
    wrap.setAttribute('data-ruze-first30-offer', '');
    wrap.innerHTML = `<strong>FIRST ORDER · 30% OFF</strong><span><b>${CODE}</b> will be applied automatically when you continue to checkout. No typing required.</span>`;
    return wrap;
  };

  const syncOfferUI = (eligible) => {
    lastEligible = eligible;
    document.querySelectorAll('[data-ruze-first30-offer]').forEach((node) => node.remove());
    if (!eligible) return;

    const drawerFooter = document.querySelector('.cart-drawer__footer');
    if (drawerFooter) {
      const total = drawerFooter.querySelector('.cart-drawer__total');
      const offer = offerMarkup();
      if (total) total.insertAdjacentElement('afterend', offer); else drawerFooter.prepend(offer);
    }

    const summary = document.querySelector('.cart-summary');
    if (summary) {
      const totalRow = summary.querySelector('.cart-summary__row');
      const offer = offerMarkup();
      if (totalRow) totalRow.insertAdjacentElement('afterend', offer); else summary.prepend(offer);
    }
  };

  const refreshOffer = async () => {
    try {
      const cart = await getCart();
      syncOfferUI(cartIsEligible(cart));
      return cartIsEligible(cart);
    } catch (error) {
      return lastEligible === true;
    }
  };

  const updateCartFromForm = async (form) => {
    if (!form || !form.querySelector('input[name="updates[]"]')) return;
    const formData = new FormData(form);
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      body: formData,
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    });
    if (!response.ok) throw new Error('Unable to update cart');
  };

  const continueToCheckout = async (form, submitter) => {
    const originalText = submitter?.textContent;
    if (submitter) {
      submitter.disabled = true;
      submitter.setAttribute('aria-busy', 'true');
      submitter.textContent = 'Applying offer…';
    }
    try {
      await updateCartFromForm(form);
      const eligible = await refreshOffer();
      window.location.assign(eligible ? discountUrl : '/checkout');
    } catch (error) {
      window.location.assign('/checkout');
    } finally {
      if (submitter) {
        submitter.disabled = false;
        submitter.removeAttribute('aria-busy');
        if (originalText) submitter.textContent = originalText;
      }
    }
  };

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const submitter = event.submitter;
    if (!submitter || submitter.getAttribute('name') !== 'checkout') return;
    if (!form.matches('#cart-form, .cart-drawer__checkout-form')) return;
    event.preventDefault();
    continueToCheckout(form, submitter);
  }, true);

  document.addEventListener('click', (event) => {
    const target = event.target.closest('a[href*="/checkout"]');
    if (!target || target.matches('[data-ruze-discount-bypass]')) return;
    const container = target.closest('.cart-summary, .cart-drawer__footer, .cart-mobile-checkout');
    if (!container) return;
    event.preventDefault();
    continueToCheckout(target.closest('form'), target);
  }, true);

  const observer = new MutationObserver(() => {
    if (lastEligible === true) syncOfferUI(true);
  });
  observer.observe(document.body, { childList: true, subtree: true });

  refreshOffer();
})();
